module.exports = __webpack_public_path__ + "static/media/black_book_logo.3de46445.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/black_book_logo.jpg
 ** module id = 780
 ** module chunks = 0
 **/